var data = {
  async init() {
    var { constants } = await app.api.constant.get();
    data.constants = constants;
  }
};

module.exports = data;